import { render, staticRenderFns } from "./concern.vue?vue&type=template&id=31b5c2ee&"
import script from "./concern.vue?vue&type=script&lang=js&"
export * from "./concern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31b5c2ee')) {
      api.createRecord('31b5c2ee', component.options)
    } else {
      api.reload('31b5c2ee', component.options)
    }
    module.hot.accept("./concern.vue?vue&type=template&id=31b5c2ee&", function () {
      api.rerender('31b5c2ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/child/concern.vue"
export default component.exports